import React, { Component } from "react";
import PropTypes from "prop-types";
import { IncomeDetails } from "@pf-loan-funnel/pf-component-library";
import SSN from "./SSN";
import Income from "./Income";
import Expense from "./Expense";
import DateOfBirth from "./DateOfBirth";
import Password from "./Password";
import Phone from "./Phone";
import Email from "./Email";
import EmailConfirm from "./EmailConfirm";
import EmploymentStatus from "./EmploymentStatus";
import Row from "../../shared_modules/common/grid/Row";
import Col from "../../shared_modules/common/grid/Col";
import EmployerName from "./EmployerName";
import JobTitle from "./JobTitle";
import { REQUIRED_EMPLOY_DETAILS } from "./PI1Form";
const APPLICANT = "applicant";
const details = [
  { text: ["Some examples of income include the following:"] },
  {
    icon: "checkmark-income",
    title: "Income from employment,",
    text: [" including full-time, part-time, freelance, or seasonal jobs"],
  },
  {
    icon: "checkmark-income",
    title: "Self-employment,",
    text: [" including any business dividends or rental income"],
  },
  {
    icon: "checkmark-income",
    title: "Any other income ",
    text: [" such as retirement, social security, or public assistance"],
  },
  {
    text: ["Important notes:"],
  },
  {
    text: ["• Non-taxable income, if included, should be increased by 25%."],
  },
  {
    text: [
      "• Alimony, child support or separate maintenance income need not to be included if you do not wish to have it considered as a basis for repaying this obligation.",
    ],
  },
  {
    text: [
      "• Married Wisconsin Residents Only: If you are applying for an individual account and your spouse is also a WI resident, combine your and your spouse’s financial information.",
    ],
  },
];

class PI1FormSecDetails extends Component {
  constructor(props) {
    super(props);
    this.validationState = {
      emailFieldsTouched: false,
    };
  }

  static defaultProps = {
    hasAutoFilled: false,
    secName: "sectionDetails",
    secTitle: "Applicant Details",
    sectionStatus: "",
    userInfo: {
      isLoggedIn: false,
      userType: APPLICANT,
      siteAuthorization: "patient",
      userAgent: "",
    },
    zeroIncomes: false,
  };

  handleEventCallback = (ev, data) => {
    const { name } = ev.target;
    const {
      onSectionCallback,
      secName,
      sectionMetadata,
      clientInfo: { inEmailVerificationPilot },
    } = this.props;

    let fieldName = name;
    const fieldMetadata = sectionMetadata.fields[fieldName];

    // TODO: refactor validations to determine form validition and error message
    // display in one area, currently there is redundancy in the
    // isValid and status checks, but the error message is determined in the component's render

    if (fieldName.includes("email") && inEmailVerificationPilot) {
      if (name === "emailConfirmation") {
        const { email } = sectionMetadata.fields;
        const isValid = data.value ? email.value === data.value : false;
        fieldMetadata.status = isValid ? "" : "invalid";
        fieldMetadata.isValid = isValid;
      }

      if (name === "email") {
        const { emailConfirmation } = sectionMetadata.fields;
        const isValid = emailConfirmation.value === data.value;
        emailConfirmation.status = isValid ? "" : "invalid";
        emailConfirmation.isValid = isValid;
      }
      this.validationState.emailFieldsTouched = fieldName.includes("email");
    } else {
      fieldMetadata.status = data.status;
      fieldMetadata.isValid = data.isValid;
    }

    fieldMetadata.value = data.value;

    if (onSectionCallback && typeof onSectionCallback === "function") {
      onSectionCallback(secName, fieldName, fieldMetadata);
    }
  };

  render() {
    const {
      shouldCollectEmploymentStatus,
      secTitle,
      userInfo,
      updateAsyncState,
      zeroIncomes,
      sectionMetadata,
      clientInfo: { inEmailVerificationPilot },
      formState,
      hasAutoFilled,
    } = this.props;

    const { isLoggedIn, userType, userAgent } = userInfo;
    const isApplicantLoggedOut = !isLoggedIn && userType === APPLICANT;
    const isNonApplicantLoggedIn = isLoggedIn && userType !== APPLICANT;
    const enableExtraEmploymentInfo = REQUIRED_EMPLOY_DETAILS.includes(
      sectionMetadata?.fields?.employmentStatus?.value
    );

    return (
      <fieldset className="pf-registration section-3 applicant-details">
        <legend className="show-for-sr">{secTitle}</legend>
        <Phone
          onEventCallback={this.handleEventCallback}
          fieldMetadata={sectionMetadata.fields.phone}
        />
        {inEmailVerificationPilot ? (
          <>
            <Email
              onEventCallback={this.handleEventCallback}
              fieldMetadata={sectionMetadata.fields.email}
              displayConfirmation
              userType={userType}
              inEmailVerificationPilot
              updateAsyncState={updateAsyncState}
            />
            <EmailConfirm
              formState={formState}
              onEventCallback={this.handleEventCallback}
              fieldMetadata={sectionMetadata.fields.emailConfirmation}
              validationState={this.validationState}
              emailFieldMetadata={sectionMetadata.fields.email}
            />
          </>
        ) : (
          (isApplicantLoggedOut || isNonApplicantLoggedIn) && (
            <Email
              onEventCallback={this.handleEventCallback}
              fieldMetadata={sectionMetadata.fields.email}
              displayConfirmation
              userType={userType}
              updateAsyncState={updateAsyncState}
            />
          )
        )}
        {isApplicantLoggedOut && (
          <Password // Password field only visible to new applicants (no providers)
            onEventCallback={this.handleEventCallback}
            fieldMetadata={sectionMetadata.fields.password}
          />
        )}
        <DateOfBirth
          onEventCallback={this.handleEventCallback}
          fieldMetadata={sectionMetadata.fields.dob}
        />
        <SSN
          onEventCallback={this.handleEventCallback}
          fieldMetadata={sectionMetadata.fields.ssn}
          userAgent={userAgent}
        />
        {shouldCollectEmploymentStatus && (
          <>
            <EmploymentStatus
              hasAutoFilled={hasAutoFilled}
              onEventCallback={this.handleEventCallback}
              fieldMetadata={sectionMetadata.fields?.employmentStatus}
            />
            <EmployerName
              hasAutoFilled={hasAutoFilled}
              enableExtraEmploymentInfo={enableExtraEmploymentInfo}
              onEventCallback={this.handleEventCallback}
              fieldMetadata={sectionMetadata.fields?.employerName}
            />
            <JobTitle
              hasAutoFilled={hasAutoFilled}
              enableExtraEmploymentInfo={enableExtraEmploymentInfo}
              onEventCallback={this.handleEventCallback}
              fieldMetadata={sectionMetadata.fields?.jobTitle}
            />
          </>
        )}
        <Income
          onEventCallback={this.handleEventCallback}
          fieldMetadata={sectionMetadata.fields.income}
          zeroIncomes={zeroIncomes}
        />
        <Row className="income-details-section">
          <Col className="sm-collapse" width={{ sm: 12, lg: 3 }} />
          <Col className="income-details" width={{ sm: 12, lg: 7 }}>
            <IncomeDetails
              header="What can I include as total annual income?"
              className="pf-income-details"
              details={details}
            />
          </Col>
        </Row>
        <Expense
          onEventCallback={this.handleEventCallback}
          fieldMetadata={sectionMetadata.fields.rent}
        />
      </fieldset>
    );
  }
}

PI1FormSecDetails.propTypes = {
  hasAutoFilled: PropTypes.bool,
  shouldCollectEmploymentStatus: PropTypes.bool.isRequired,
  userInfo: PropTypes.object.isRequired,
  clientInfo: PropTypes.object.isRequired,
  secTitle: PropTypes.string.isRequired,
  sectionMetadata: PropTypes.object.isRequired,
  onSectionCallback: PropTypes.func.isRequired,
  updateAsyncState: PropTypes.func.isRequired,
  sectionStatus: PropTypes.string.isRequired,
  secName: PropTypes.string,
  zeroIncomes: PropTypes.bool,
  formState: PropTypes.object.isRequired,
};

export default PI1FormSecDetails;

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');